import React from 'react';
import { useParams } from 'react-router-dom';
import Template1 from './Template1';
import Template2 from './Template2';
import Template3 from './Template3';
import Template4 from './Template4';
import Template5 from './Template5';

const Builder = () => {
  const { id } = useParams();

  const templates = {
    1: <Template1 />,
    2: <Template2 />,
    3: <Template3 />,
    4: <Template4 />,
    5: <Template5 />
  };

  return templates[id] || <div>Template not found</div>;
};

export default Builder;